<div class="container">
  <div class="row no-gutters">
    <div class="col-12">
      <div class="d-flex popup-head align-items-center">
        <div class="popup-title mr-auto" translate>lblAddPreferences</div>
        <div class="float-right">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
          </a>
        </div>

      </div>
      <form [formGroup]="addPreferencesForm" (ngSubmit)="addPreferences()">
        <div class="scrollbar">
          <div class="card-content">
            <div class="card-body p-0">
              <div class="row">
                <div class="col-md-6">
                  <div class="af-form-group">
                    <label for="service" translate>lblBrand
                      <strong class="mlt6 required"> * </strong> </label>
                    <div class='lbl-info'>
                      <div class="form-group">
                        <ng-select class="" formControlName="brand"
                          [ngClass]="{'is-invalid': cpf.brand.invalid && cpf.brand.touched}"
                          placeholder="{{ 'lblSelectBrand' | translate }}">
                          <option disabled [ngValue]="null" translate>lblBrandRequired</option>
                          <ng-template ng-header-tmp>
                            <span class="mbold w-66px" translate>lblCode</span>
                            <span class="mbold" translate>lblBrand</span>
                          </ng-template>

                          <ng-option *ngFor="let brand of brandList" [value]="brand.brandCode">
                            <span class="w-66px">{{brand.brandCode}}</span>
                            <span class="mx-2 hide-ng-dropdown-panel">-</span>
                            <span>{{brand.brandName}}</span>
                          </ng-option>
                        </ng-select>

                        <div *ngIf="cpf.brand.invalid && (cpf.brand.dirty || cpf.brand.touched)"
                          class="help-block text-danger">
                          <div *ngIf="cpf.brand.errors.required"><span translate>lblBrandRequired</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="w-100 px-0" *ngIf="c.controls">
                  <div class="col-md-6" *ngFor="let ticket of c.controls; let i = index">
                    <div [formGroup]="ticket" class="">
                      <div class="af-form-group">
                        <label for="name" translate>lblQuestion<span> in
                            {{allLanguage[i].value}}</span>
                          <strong class="mlt6 required"> * </strong> </label>
                        <div class='lbl-info'>
                          <input formControlName="name" class="form-control mb-2" required maxlength="50"
                            [ngClass]="{'is-invalid': cpf.question.invalid && cpf.question.touched}">
                          <div *ngIf="cpf.question.touched && (cpf.question.errors?.required)"
                            class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                              aria-hidden="true"></em>
                              lblQuestionFieldRequired
                          </div>
                        </div>
                      </div>
                      <div class="af-form-group" style="display: none;">
                        <label for="languageId" translate>lblLanguageId</label>
                        <div class="lbl-info">
                          <input formControlName="languageId" class="form-control mb-2" [ngModel]="allLanguage[i].id"
                            required maxlength="30">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-100 px-0" *ngIf="t.controls">
                  <div class="col-md-6" *ngFor="let ticket of t.controls; let i = index">
                    <div [formGroup]="ticket" class="">
                      <div class="af-form-group">
                        <label for="description" translate>lblQuestionDescription<span> in
                            {{allLanguage[i].value}}</span>
                          <strong class="mlt6 required"> * </strong> </label>
                        <div class='lbl-info'>
                          <input formControlName="description" class="form-control mb-2" required maxlength="200"
                            [ngClass]="{'is-invalid': cpf.questionDescription.invalid && cpf.questionDescription.touched}">
                          <div *ngIf="cpf.questionDescription.touched && (cpf.questionDescription.errors?.required)"
                            class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                              aria-hidden="true"></em>
                            lblQuestionDescriptionRequired
                          </div>
                        </div>
                      </div>
                      <div class="af-form-group" style="display: none;">
                        <label for="languageId" translate>lblLanguageId</label>
                        <div class="lbl-info">
                          <input formControlName="languageId" class="form-control mb-2" [ngModel]="allLanguage[i].id"
                            required maxlength="30">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 af-form-group">
                  <label for="template-edit-image" translate>lblImage </label>
                  <div class="lbl-info">
                    <div class="custom-file">
                      <label class="btn btn-outline-primary d-inline-block" for="select-files"
                        translate>lblUploadImage</label>
                      <input type="file" id="select-files" class="" hidden formControlName="image"
                        accept=".png, .jpg, .jpeg" (change)="onChangeFileUpload($event.target.files)">
                    </div>
                    <ng-container *ngIf="preference.image">
                      <div *ngIf="preference.preferenceImage" class="border mt-3 p-1 d-inline-block">
                        <img height="50" [src]="preference.preferenceImage" id="UploadImage" alt="image does not found."
                          onError="this.onerror=null; this.src='../../../../../assets/images/no-image-icon.png'"
                          class="carimg">
                      </div>
                    </ng-container>
                  </div>
                </div>
                <ng-container *ngFor="let item of answerInputsControls;let i = index">
                  <div class="col-md-10 af-form-group">
                    <label for="service" translate>lblAnswerforPreferenceQuestion
                      <strong class="mlt6 required"> * </strong> </label>
                    <div class='lbl-info' formArrayName="answers">
                      <input name="answer{{i}}" type="text" placeholder="{{ 'Enter answer here' | translate }}"
                        class="form-control" [formControlName]="i" maxlength="20" required />
                      <div class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                          aria-hidden="true"></em>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2 af-form-group">
                    <label for="service" translate>&nbsp; </label>
                    <div class='lbl-info'>
                      <input type="button" (click)="removeAnswer(i)" value="Remove"
                        class="btn btn-outline-primary d-inline-block">
                    </div>
                  </div>
                </ng-container>
                <div class="col-md-12 af-form-group">
                  <small class="text-danger" *ngIf="isMaxAnswer" translate>
                    lblMaxAnswer
                  </small>
                  <div class='lbl-info'>
                    <div class='lbl-info'>
                      <input type="button" class="btn btn-outline-primary d-inline-block" style="align-items: center;"
                        value="ADD Answer" (click)="addPreferenceAnswer()">
                    </div>
                  </div>
                </div>
                <div class="col-md-6 af-form-group">
                  <label for="template-edit-image" translate>&nbsp; </label>
                  <div class="lbl-info">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input" id="isActive" formControlName="isActive">
                      <label class="custom-control-label" for="isActive" translate>lblActive</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-3 bg-light pp-footer-top-brdr">
          <div class="d-flex flex-sm-row flex-column justify-content-end">
            <button type="submit" class="btn btn-primary mr-sm-2 btn-lg" aria-label="Center Align"
              [disabled]="!addPreferencesForm.valid" translate><em
                class="far fa-save font16 align-top mr-2"></em>lblSaveChanges</button>
            <a (click)="OnClose()" class="btn btn-secondary btn-lg" translate><em
                class="far fa-times-circle font16 align-top mr-2"></em>lblCancel</a>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>